import { fbt } from 'fbtee'
import { Heart } from 'lucide-react'
import { Button } from '../../../components/ui/button'

/** Hearts, for this event, every lineup artist the viewer already follows — a deliberate bring-over, since each event starts clean. */
export function FollowedArtistsCta({ count, onAdd }: { count: number; onAdd: () => void }) {
  return (
    <Button variant="outline" size="sm" className="w-full" onClick={onAdd} data-testid="followed-artists-cta">
      <Heart className="text-interested" />
      {fbt(
        'Add the ' + fbt.plural('artist', count, { showCount: 'ifMany', many: 'artists' }) + ' you follow',
        'Button above an event lineup that hearts, for this event, every lineup artist the user already follows',
      )}
    </Button>
  )
}
